import * as Yup from 'yup';
import { email, phoneNumber, stringMax } from '@/lib/yup';

const ContactFormSchema = Yup.object({
  subject: stringMax(100).required('validation.is_required'),
  name: stringMax(50).required('validation.is_required'),
  phone: phoneNumber.required('validation.is_required'),
  email: email.required('validation.is_required'),
  city: stringMax(50).nullable().required('validation.is_required'),
  message: stringMax(1000),
});

export type ContactFormSchemaType = Yup.InferType<typeof ContactFormSchema>;

export default ContactFormSchema;
